import { css } from 'styled-components';

export const withOneLineEllipsis = css`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
